import React, { RefAttributes, forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { AlertIcon } from 'src/assets/icons'

export interface ModalProps {
  title: string
  description: string
  action: () => Promise<any> | void
  cancel?: () => Promise<any> | void
  clickCloseIcon?: () => Promise<any> | void
}

export interface CustomConfirmationModalRef {
  showModal: (props: ModalProps) => void
  hideModal: () => void
  setLoading: (flag: boolean) => void
}

export const modalRef = React.createRef<CustomConfirmationModalRef>()

const CustomConfirmationModal: React.FC<RefAttributes<CustomConfirmationModalRef>> = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [modalProps, setModalProps] = useState<ModalProps>({
    title: '',
    description: '',
    action: () => Promise.resolve(),
    cancel: () => Promise.resolve(),
    clickCloseIcon: () => Promise.resolve(),
  })

  const hideModal = () => setOpen(false)
  const showModal = () => setOpen(true)

  useImperativeHandle(ref, () => ({
    showModal: (prop) => {
      showModal()
      setModalProps(prop)
    },
    hideModal,
    setLoading,
  }))

  // show modal when add successfully
  useEffect(() => {
    const button: HTMLButtonElement | null = document.querySelector('button.ant-modal-close')
    if (button) {
      button.addEventListener('click', () => modalProps.clickCloseIcon?.())
    }
    return () => {
      button?.removeEventListener('click', () => {})
    }
  }, [modalProps])

  return (
    <ActionConfirmationModal
      title={modalProps.title}
      descriptionType='string'
      description={modalProps.description}
      footer={[
        <Button type='default' onClick={modalProps.cancel} disabled={loading} key={'cancel'}>
          {t('common:no')}
        </Button>,
        <Button type='primary' key={'confirm'} onClick={modalProps.action} disabled={loading} loading={loading}>
          {t('common:yes')}
        </Button>,
      ]}
      isOpen={open}
      onClose={hideModal}
      icon={<AlertIcon width={80} height={80} />}
    />
  )
})

export default CustomConfirmationModal
